export const filterSectionSpacing = 18
export const filterOptionBottomSpacing = 4

export type EmptyStateFilter = '(no tags)' | '(no URL)'
export const emptyStateFilters: EmptyStateFilter[] = ['(no tags)', '(no URL)']

export const emptyStateFilterI18nConfig: Record<EmptyStateFilter, string> = {
  '(no tags)': 'title_vulnerabilitiesFilter_noTagged',
  '(no URL)': 'title_vulnerabilitiesFilter_noURL'
}

export const isEmptyStateFilter = (label: string) => {
  return !!emptyStateFilters.find((item) => item === label)
}
